import ScienceBehindWlTrackingMacrosPoster from "../../../../../images/posters/avatar/education/science-behind.webp";
import MenopausePart1Poster from "../../../../../images/posters/avatar/education/avatar-menopause-p1.jpg";
import MenopausePart2Poster from "../../../../../images/posters/avatar/education/avatar-menopause-p2.jpg";

const avatarEducation = [
  {
    "title": "Science Behind WL & Tracking Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Science+Behind+WL+%26+Tracking+Macros.mp4",
    "thumbnail": ScienceBehindWlTrackingMacrosPoster,
    "length": "29:06"
  },
  {
    "title": "Menopause Part 1",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Menopause+Part+1.mp4",
    "thumbnail": MenopausePart1Poster,
    "length": "31:48"
  },
  {
    "title": "Menopause Part 2",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+Menopause+Part+2.mp4",
    "thumbnail": MenopausePart2Poster,
    "length": "32:26"
  }
  
];

export default avatarEducation; 